export default __webpack_public_path__ + "static/supersupplier-logo-dark-edaa40c5be3df78aeb396c352aae76be.png";